import { FeatureProvider } from './factory';
import { useFeatureApiAccess } from './flag-api-access/useFeatureApiAccess';
import {
  useHasAccessToAccountCodes,
  useHasAccessToCompliance,
  useHasAccessToContacts,
  useHasAccessToDirectoryBeta,
  useHasAccessToDuesRemittanceBeta,
  useHasAccessToFacultyAccess,
  useHasAccessToFeePromotion,
  useHasAccessToPosBeta,
  useHasAccessToProductVariants,
  useHasAccessToQuickbooks,
  useHasAccessToSalesTaxBeta,
  useHasAccessToStoreTips,
  useHasAccessToStudentFeesBeta,
  useHasAccessToTicketedEventsBeta,
  useHasAccessToUnitDataBeta,
} from './flags/causeFlags';
import { useFeatureOverrideFlag } from './flags/feature-override-flag';
import {
  useUserInternalPreview,
  useUserReleaseStudentFees,
} from './flags/userFlags';

type featureContext = {
  causeId?: string;
};

type Props = {
  causeId?: string;
  children?: React.ReactNode | React.ReactNode[];
} & featureContext;

const FeatureProvider_Core = ({ children, causeId }: Props) => {
  return (
    <FeatureProvider
      value={{
        causeId,
        features: {
          'feature.override': useFeatureOverrideFlag,
          'compliance.beta': useHasAccessToCompliance,
          accountCodes: useHasAccessToAccountCodes,
          'ticketedEvents.beta': useHasAccessToTicketedEventsBeta,
          'user.studentFees': useUserReleaseStudentFees,
          internalPreview: useUserInternalPreview,
          quickbooks: useHasAccessToQuickbooks,
          'contacts.beta': useHasAccessToContacts,
          'pos.beta': useHasAccessToPosBeta,
          'student_fees.beta': useHasAccessToStudentFeesBeta,
          'unit_data.beta': useHasAccessToUnitDataBeta,
          store_tips: useHasAccessToStoreTips,
          '2025-decreased-store-pricing': useFeatureApiAccess,
          'district-ticketed-events': useFeatureApiAccess,
          'ticketing-dashboard': useFeatureApiAccess,
          'directory.beta': useHasAccessToDirectoryBeta,
          fee_promotion: useHasAccessToFeePromotion,
          faculty_access: useHasAccessToFacultyAccess,
          'dues_remittance.beta': useHasAccessToDuesRemittanceBeta,
          product_variants: useHasAccessToProductVariants,
          'sales_tax.beta': useHasAccessToSalesTaxBeta,
        },
      }}
    >
      {children}
    </FeatureProvider>
  );
};

export { FeatureProvider_Core };
